/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { Select, TextField, Typography, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup } from "@material-ui/core";
import { scheduleEditProps } from "./ScheduleEdit.d";
import useInitialAppData from "../../Hook/UseInitialAppData";
import MultiSelect from "../MultiSelect/MultiSelect";
import Button from "jb_component_library/components/Button";
import { useGetCriterias, usePostSchedules, usePutSchedules } from "../../api/replenishmentApi";
import { defaultSchedule } from "../../api/Defaults/defaults";

const ScheduleEdit: React.FC<scheduleEditProps> = (props) => {
	const {
		schedule,
		refreshCallback,
	} = props;

	const [formValues, setFormValues] = useState(schedule);
	const { locations } = useInitialAppData();
	const defaultDestinationLocations = formValues.destinationLocations.map(m => {
		const loc = locations.find(l => l.id === m.locationId.toString());
		return({id: m.locationId, name: loc?.name});
	});
	const [putSchedules] = usePutSchedules();
	const [postSchedules] = usePostSchedules();
	const [{ data: criterias }] = useGetCriterias();
	
	useEffect(() => {
		setFormValues(schedule);
	}, [schedule]);


	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormValues({
		  ...formValues,
		  [name]: value,
		});
	  };
	const handleCheckedChange = (e) => {
		const { name, checked: value } = e.target;
		setFormValues({
			...formValues,
			[name]: value,
		});
	};
	
	  const handleDayChange = (e) => {
		const { days } = formValues;
		const { name, checked } = e.target;
		const updatedDays = days.filter(m => m !== name);
		if(checked) {
			updatedDays.push(name);
		}
		setFormValues({
			...formValues,
			days: updatedDays,
		});
	}

	const handleSourceLocationChange = (e) => {
		const { name, value } = e.target;
		const selectedLocation = locations.find(l => l.id === value);
		setFormValues({
			...formValues,
			timeZone: selectedLocation?.timeZoneName ?? "",
			[name]: value,
		})
	}

	const handleDestinationChange = (e) => {
		const { destinationLocations } = formValues;
		const { name, checked } = e.target;
		const updatedDestinationLoctions = destinationLocations.filter(m => m.locationId.toString() !== name);
		if(checked) {
			updatedDestinationLoctions.push({ locationId: name, isActive: true });
		}
		setFormValues({
			...formValues,
			destinationLocations: updatedDestinationLoctions,
		});
	}

	const handleSave = async (e) => {
		if(formValues.id === defaultSchedule.id) {
			postSchedules(formValues)
				.then(() => {
					console.log("Success");
					refreshCallback();
				})
				.catch((e) => {
					console.log(e);
				});
		} else {
			putSchedules(formValues)
				.then(() => {
					console.log("Success");
					refreshCallback();
				})
				.catch((e) => {
					console.log(e);
				});
		}
		
	}

	return (
		<Grid>
			<Grid container spacing={2} sx={{paddingTop: 2, paddingBottom: 2}}>
				<Grid container item xs={8} spacing={4}>
					<Grid item xs={12} md={6}>
						<Typography variant="h3">Info</Typography>
						<TextField
							id="name"
							name="name"
							label="Name"
							type="text"
							value={formValues.name}
							onChange={handleInputChange}
							variant="outlined"
						/>
					</Grid>
					<Grid item container direction="column" xs={12} md={6}>
						<Typography variant="h3">Time</Typography>
						<Grid container direction="row" spacing={1}>
							<Grid item>
								<TextField
									id="runTime"
									name="runTime"
									label="Trigger Time"
									type="time"
									defaultValue="06:30"
									InputLabelProps={{
										shrink: true,
									}}
									inputProps={{
										step: 300, // 5 min
									}}
									value={formValues.runTime}
									onChange={handleInputChange}
									variant="outlined"
								/>
							</Grid>
							<Grid item>
								<TextField
									id="aautoApprovalTime"
									name="autoApprovalTime"
									label="Approval Time"
									type="time"
									defaultValue="10:00"
									InputLabelProps={{
										shrink: true,
									}}
									inputProps={{
										step: 300, // 5 min
									}}
									value={formValues.autoApprovalTime}
									onChange={handleInputChange}
									variant="outlined"
								/>
							</Grid>
							<Grid item>
								<FormGroup>
									<FormControlLabel control={<Checkbox checked={formValues.isActive} onChange={handleCheckedChange} />} label="Active" name="isActive" />
								</FormGroup>
							</Grid>
							<Grid item>
							<TextField
								disabled
								id="outlined-disabled"
								label="Timezone"
								value={formValues.timeZone}
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid item container direction="column" xs={12} md={6} spacing={4}>
						<Grid item>
							<Typography variant="h3">Location</Typography>
							<FormControl fullWidth variant="outlined" sx={{ marginBottom: 2, minWidth: 80 }}>
								<InputLabel id="select-source-location-label">Source Location</InputLabel>
								<Select
									id="select-source-location"
									name="sourceLocationId"
									labelId="select-source-location-label"
									label="Source Location"
									value={formValues.sourceLocationId}
									onChange={handleSourceLocationChange}
									variant="outlined"
								>
									{locations.map(m => {
										return (<MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>)
									})}
								</Select>
							</FormControl>
						</Grid>
						<Grid item>
							<MultiSelect
								title="Destinations"
								options={locations}
								values={defaultDestinationLocations}
								onSelectionChange={handleDestinationChange}
							/>
						</Grid>
					</Grid>
					<Grid item container direction="column" xs={12} md={6}>
						<Typography variant="h3">Criteria</Typography>
						<FormControl fullWidth variant="outlined">
							<InputLabel id="select-criteria-label">Criteria</InputLabel>
							<Select
								id="select-criteria"
								name="criteriaId"
								labelId="select-criteria-label"
								label="Criteria"
								value={formValues.criteriaId}
								onChange={handleInputChange}
								variant="outlined"
							>
								{criterias?.map(m => {
									return (<MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>)
								})}
							</Select>
						</FormControl>
					</Grid>
				</Grid>
				<Grid container item xs={12} md={4} direction="column">
					<Typography variant="h3">Frequency</Typography>
					<FormControl>
						<RadioGroup
							name="radio-group-frequency"
							value={formValues.frequency}
						>
							<FormControlLabel value="Daily" control={<Radio />} label="Daily" onChange={handleInputChange} />
						</RadioGroup>
					</FormControl>
					<FormControl>
						<FormLabel id="form-group-days-label">Day</FormLabel>
						<FormGroup>
							<FormControlLabel name="Monday" control={<Checkbox checked={formValues.days.includes("Monday")} />} label="Monday" onChange={handleDayChange}/>
							<FormControlLabel name="Tuesday" control={<Checkbox checked={formValues.days.includes("Tuesday")} />} label="Tuesday" onChange={handleDayChange}/>
							<FormControlLabel name="Wednesday" control={<Checkbox checked={formValues.days.includes("Wednesday")} />} label="Wednesday" onChange={handleDayChange}/>
							<FormControlLabel name="Thursday" control={<Checkbox checked={formValues.days.includes("Thursday")} />} label="Thursday" onChange={handleDayChange}/>
							<FormControlLabel name="Friday" control={<Checkbox checked={formValues.days.includes("Friday")} />} label="Friday" onChange={handleDayChange}/>
							<FormControlLabel name="Saturday" control={<Checkbox checked={formValues.days.includes("Saturday")} />} label="Saturday" onChange={handleDayChange}/>
							<FormControlLabel name="Sunday" control={<Checkbox checked={formValues.days.includes("Sunday")} />} label="Sunday" onChange={handleDayChange}/>
						</FormGroup>
					</FormControl>
				</Grid>
				
				<Grid container item>
					<Button type="primary" onClick={handleSave}>Save</Button>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ScheduleEdit;
